import { Link, useLocation } from "react-router-dom";
import { useRef, useEffect } from "react";
import styles from "./Navigation.module.css";
import BlackButton from "../BlackButton/BlackButton.js";
import { useTranslation } from "react-i18next";

const Navigation = ({
  tabs,
  basePath,
  variant, // "main", "sub", "tab"
  useSaveButton = false,
}) => {
  const { t } = useTranslation();
  const location = useLocation();
  const menuToggleRef = useRef(null);

  const isMain = variant === "main";

  const closeMenu = () => {
    const cb = menuToggleRef.current;
    if (cb && cb.checked) cb.checked = false;
  };

  useEffect(() => {
    closeMenu();
  }, [location.pathname]);

  const getNavClass = () => {
    switch (variant) {
      case "main":
        return styles.mainNav;
      case "sub":
        return styles.subNav;
      case "tab":
        return styles.tabNav;
      default:
        return "";
    }
  };

  const renderLabel = (label) => {
    if (label.startsWith("M_")) {
      return (
        <>
          <span className={styles.tabBlue}>{t("common.m")}_</span>
          {label.slice(2)}
        </>
      );
    }
    if (label.startsWith("F_")) {
      return (
        <>
          <span className={styles.tabRed}>{t("common.f")}_</span>
          {label.slice(2)}
        </>
      );
    }
    return label;
  };

  // active 매칭 로직(필요시 정확도 높이기)
  const isActive = (path) => {
    const full = `${basePath}/${path}`;
    return location.pathname === full || location.pathname.startsWith(full + "/");
  };

  return (
    <div className={isMain ? `${styles.headerInner}` : styles.navWrap}>
      {isMain && (
        <>
          <input
            type="checkbox"
            className={styles.menuToggle}
            id="menu-toggle-main"
            ref={menuToggleRef}
          />
          <div className={styles.mobileBar}>
            <label htmlFor="menu-toggle-main" className={styles.menuIcon}>
              <span></span>
            </label>
          </div>
        </>
      )}

      <div className={getNavClass()}>
        <nav>
          <ul className={variant === "tab" ? styles.hScroll : undefined}>
            {tabs.map((tab, index) => (
              <li key={index}>
                <Link
                  to={`${basePath}/${tab.path}`}
                  className={`${styles.link} ${isActive(tab.path) ? styles.active : ""}`}
                  onClick={closeMenu}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") closeMenu();
                  }}
                >
                  {renderLabel(tab.label)}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        {useSaveButton && <BlackButton text="저장" />}
      </div>
    </div>
  );
};

export default Navigation;
